import { Component, Injectable, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDateRangeSelectionStrategy, DateRange, MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { ConsultationInfoService } from 'src/app/services/StoreService/ConsultationInfoService/consultation-info-service.service';

@Injectable()
export class FiveDayRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  constructor(
    private _dateAdapter: DateAdapter<D>,
    private consultationInfoService: ConsultationInfoService
  ) {}

  selectionFinished(date: D | null): DateRange<D> {
    return this._createFiveDayRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createFiveDayRange(activeDate);
  }

  private _createFiveDayRange(date: D | null): DateRange<D> {
    if (date) {
      const start = this._dateAdapter.addCalendarDays(date, 0);
      const end = this._dateAdapter.addCalendarDays(date, 6);
      const lastWeekStart = this._dateAdapter.addCalendarDays(date, -7);
      const lastWeekEnd = this._dateAdapter.addCalendarDays(date, -1);
      this.consultationInfoService.newWeekSelected(start, end);
      this.consultationInfoService.newLastWeek(lastWeekStart, lastWeekEnd)
      this.consultationInfoService.newYearAndMonth(null, null);
      return new DateRange<D>(start, end);
    }

    return new DateRange<D>(null, null);
  }
}

/** @title Date range picker with custom a selection strategy */
@Component({
  selector: 'app-range-selection-strategy',
  templateUrl: 'range-selection-strategy.component.html',
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: FiveDayRangeSelectionStrategy,
    },
  ],
})
export class DateRangePickerSelectionStrategy implements OnInit {

  date = new Date();
  max = this.modifyDate(this.date, -7);
  min = "2018-01-02";

  constructor(){}

  ngOnInit(){}

  modifyDate(date, days){
    date.setDate(date.getDate() + days);
    return date;
  }

}
